<span
  class="material-symbols-outlined"
  [attr.aria-label]="description()"
  [style.fontSize.px]="size()"
>
  {{ name() }}
</span>
